import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-travel-distance',
	templateUrl: './travel-distance.component.html',
	styleUrls: ['./travel-distance.component.scss']
})
export class TravelDistanceComponent implements OnChanges {
	@Input() globalStats: any;
	@Input() lsfStats: any;
	@Input() lpcStats: any;
	@Input() pdnStats: any;
	@Input() oralStats: any;
	@Input() stats: any;
	@Input() categorie = 1;
	option: EChartsOption;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(protected dateutil: DateUtils, private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	ngOnChanges(changes: any) {
		if (isNaN(this.globalStats)) {
			try {
				this.updatePieChart();
			} catch (error) {}
		}
	}

	updatePieChart(): void {
		if (this.isSESSAD) {
			this.option = {
				title: {
					text: 'Par compétence',
					textStyle: { color: THEME_COLOR_MAIN },
					subtext: '',
					subtextStyle: { color: THEME_COLOR_MAIN },
					left: 'center'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : ({d}%)'
				},
				series: [
					{
						name: 'Distance parcourue',
						type: 'pie',
						radius: '50%',
						data: [
							{
								value:
									this.lpcStats.beanParametreStatistiqueDistance
										.distanceMoyenne,
								name: 'LPC',
								itemStyle: { color: THEME_COLOR_BLUE }
							},
							{
								value:
									this.lsfStats.beanParametreStatistiqueDistance
										.distanceMoyenne,
								name: 'LSF',
								itemStyle: { color: THEME_COLOR_GREEN }
							},
							{
								value:
									this.pdnStats.beanParametreStatistiqueDistance
										.distanceMoyenne,
								name: 'PDN',
								itemStyle: { color: THEME_COLOR_PINK }
							},
							{
								value:
									this.oralStats.beanParametreStatistiqueDistance
										.distanceMoyenne,
								name: 'Oral',
								itemStyle: { color: THEME_COLOR_VIOLET }
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
		} else if (this.isSAAD) {
			this.option = {
				title: {
					text: 'Par compétence',
					textStyle: { color: THEME_COLOR_MAIN },
					subtext: '',
					subtextStyle: { color: THEME_COLOR_MAIN },
					left: 'center'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} : ({d}%)'
				},
				series: [
					{
						name: 'Distance parcourue',
						type: 'pie',
						radius: '50%',
						data: [
							{
								value:
									this.globalStats.beanParametreStatistiqueDistance
										.distanceMoyenne,
								name: 'Aide à domicile',
								itemStyle: { color: THEME_COLOR_BLUE }
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
		}
	}

	// ngOnInit(): void {}

	convertToKms(dist: number): number {
		return dist / 1000.0;
	}
}
